import React, { Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { LicenseInfo } from '@mui/x-data-grid-pro';

import CodeMngPage from './pages/codemng/CodeMngPage';
import EmployeeListPage from './pages/employeemng/EmployeeListPage';
import EmployeeMngPage from './pages/employeemng/EmployeeMngPage';

import LoginPage from './pages/login/LoginPage';
import MainPage from './pages/main/MainPage';
import PartnerAddPage from './pages/partnermng/PartnerAddPage';
import PartnerEditPage from './pages/partnermng/PartnerEditPage';
import PartnerListPage from './pages/partnermng/PartnerListPage';
import PartnerMngPage from './pages/partnermng/PartnerMngPage';
import ProductAddPage from './pages/productmng/ProductAddPage';
import ProductListPage from './pages/productmng/ProductListPage';
import ProductMngPage from './pages/productmng/ProductMngPage';

import ProductEditPage from './pages/productmng/ProductEditPage';
import ChanceMngPage from './pages/chancemng/ChanceMngPage';
import ChanceListPage from './pages/chancemng/ChanceListPage';
import EmployeeAddPage from './pages/employeemng/EmployeeAddPage';
import EmployeeEditPage from './pages/employeemng/EmployeeEditPage';
import PaymentMngPage from './pages/paymentmng/PaymentMngPage';

import TaxbillMngPage from './pages/taxbillmng/TaxbillMngPage';
import TaxbillListPage from './pages/taxbillmng/TaxbillListPage';
import TaxbillAddPage from './pages/taxbillmng/TaxbillAddPage';
import TaxbillEditPage from './pages/taxbillmng/TaxbillEditPage';
import PartnerViewPage from './pages/partnermng/PartnerViewPage';
import ProductViewPage from './pages/productmng/ProductViewPage';
import EmployeeViewPage from './pages/employeemng/EmployeeViewPage';
import ProfileMngPage from './pages/profilemng/ProfileMngPage';
import ProfileViewPage from './pages/profilemng/ProfileViewPage';
import ProfileEditPage from './pages/profilemng/ProfileEditPage';
import TaxbillViewPage from './pages/taxbillmng/TaxbillViewPage';

import ChanceDetailPage from './pages/chancemng/ChanceDetailPage';
import ChanceStepPage from './pages/chancemng/ChanceStepPage';
import TechMngPage from './pages/techmng/TechMngPage';

import TechStepPage from './pages/techmng/TechStepPage';
import TechProjectListPage from './pages/techmng/TechProjectListPage';
import TechProjectDetailPage from './pages/techmng/TechProjectDetailPage';

import ProjectMngPage from './pages/projectmng/ProjectMngPage';
import ProjectListPage from './pages/projectmng/ProjectListPage';
import ProjectDetailPage from './pages/projectmng/ProjectDetailPage';
import ProjectStepPage from './pages/projectmng/ProjectStepPage';

import MaintanceMngPage from './pages/maintancemng/MaintanceMngPage';
import MaintanceListPage from './pages/maintancemng/MaintanceListPage';
import MaintanceDetailPage from './pages/maintancemng/MaintanceDetailPage';
import MaintanceStepPage from './pages/maintancemng/MaintanceStepPage';

import EtcMngPage from './pages/etcmng/EtcMngPage';
import EtcListPage from './pages/etcmng/EtcListPage';
import EtcDetailPage from './pages/etcmng/EtcDetailPage';
import EtcStepPage from './pages/etcmng/EtcStepPage';

import InvoiceMaintenanceMngPage from './pages/invoiceMaintenanceMng/InvoiceMaintenanceMngPage';
import PurchaseMaintenanceMngPage from './pages/purchaseMaintenanceMng/PurchaseMaintenanceMngPage';


import ReqTechMngPage from './pages/reqtechmng/ReqTechMngPage';
import ReqTechListPage from './pages/reqtechmng/ReqTechListPage';
import ReqTechViewPage from './pages/reqtechmng/ReqTechViewPage';
import PlanTechMngPage from './pages/plantechmng/PlanTechMngPage';
import PlanTechListPage from './pages/plantechmng/PlanTechListPage';
import PlanTechViewPage from './pages/plantechmng/PlanTechViewPage';
import RsltTechMngPage from './pages/rslttechmng/RsltTechMngPage';
import RsltTechListPage from './pages/rslttechmng/RsltTechListPage';
import RsltTechViewPage from './pages/rslttechmng/RsltTechViewPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import DeptMngPage from './pages/deptmng/DeptMngPage';
import DeptViewPage from './pages/deptmng/DeptViewPage';
import ApprovalMngPage from './pages/approvalmng/ApprovalMngPage';
import ApprovalListPage from './pages/approvalmng/ApprovalListPage';
import ApprovalViewPage from './pages/approvalmng/ApprovalViewPage';
import DeptEditPage from './pages/deptmng/DeptEditPage';
import ScheduleMngPage from './pages/schedulemng/ScheduleMngPage';
import ScheduleViewPage from './pages/schedulemng/ScheduleViewPage';
import AuthMenuMngPage from './pages/authmenumng/AuthMenuMngPage';
import AuthMenuViewPage from './pages/authmenumng/AuthMenuViewPage';
import UserMenuMngPage from './pages/usermenumng/UserMenuMngPage';
import UserMenuViewPage from './pages/usermenumng/UserMenuViewPage';
import SaleGoalMngPage from './pages/salesgoalmng/SaleGoalMngPage';
import SaleGoalViewPage from './pages/salesgoalmng/SaleGoalViewPage';
import SaleGoalEditPage from './pages/salesgoalmng/SaleGoalEditPage';
import InventoryMngPage from './pages/inventorymng/InventoryMngPage';

import NoticeMngPage from './pages/noticemng/NoticeMngPage';
import GoalSettingMngPage from './pages/goalsetting/GoalSettingMngPage';
import GoalSettingPage from './pages/goalsetting/GoalSettingPage';
import GoalDeptUserPage from './pages/goalsetting/GoalDeptUserPage';
import InventoryProductsPage from './pages/inventorymng/InventoryProductsPage';
import InventoryHistoryPage from './pages/inventorymng/InventoryHistoryPage';

import TaxIssuedMngPage from './pages/taxIssuedmng/TaxIssuedMngPage';
import TaxIssuedListPage from './pages/taxIssuedmng/TaxIssuedListPage';
import TaxIssuedAddPage from './pages/taxIssuedmng/TaxIssuedAddPage';
import TaxIssuedViewPage from './pages/taxIssuedmng/TaxIssuedViewPage';
import TaxIssuedEditPage from './pages/taxIssuedmng/TaxIssuedEditPage';
import PaymentListPage from './pages/paymentmng/PaymentListPage';
import PaymentAddPage from './pages/paymentmng/PaymentAddPage';
import PaymentViewPage from './pages/paymentmng/PaymentViewPage';
import PaymentEditPage from './pages/paymentmng/PaymentEditPage';
import TechStatMngPage from './pages/techstat/TechStatMngPage';
import TechStatViewPage from './pages/techstat/TechStatViewPage';
import ForecastMonthStatMngPage from './pages/forecastmonthstat/ForecastMonthStatMngPage';
import ForecastMonthStatViewPage from './pages/forecastmonthstat/ForecastMonthStatViewPage';
import ForecastStatMngPage from './pages/forcaststat/ForecastStatMngPage';
import ForecastStatViewPage from './pages/forcaststat/ForecastStatViewPage';
import ChanceAddForecastPage from './pages/chancemng/ChanceAddForecastPage';
import ProjectDeptStatMngPage from './pages/project_dept_stat/ProjectDeptStatMngPage';
import ProjectDeptStatViewPage from './pages/project_dept_stat/ProjectDeptStatViewPage';
import VendorDeptStatMngPage from './pages/vendor_dept_stat/VendorDeptStatMngPage';
import VendorDeptStatViewPage from './pages/vendor_dept_stat/VendorDeptStatViewPage';
import ProjectDeptCountMngPage from './pages/project_dept_count/ProjectDeptCountMngPage';
import ProjectDeptCountViewPage from './pages/project_dept_count/ProjectDeptCountViewPage';
import MaintanceDeptStatMngPage from './pages/maintance_dept_stat/MaintanceDeptStatMngPage';
import MaintanceDeptStatViewPage from './pages/maintance_dept_stat/MaintanceDeptStatViewPage';
import GoalStaticsMngPage from './pages/goal_statics/GoalStaticsMngPage';
import GoalStaticsViewPage from './pages/goal_statics/GoalStaticsViewPage';
import GoalStaticsViewDetailPage from './pages/goal_statics/GoalStaticsViewDetailPage';
import BondDeptListPage from './pages/bonds-depts/BondsDeptsListPage';
import CollectBuyListPage from './pages/collects_buys/CollectBuyListPage';
import TaxbillStaticsMngPage from './pages/taxbill_statics/TaxbillStaticsMngPage';
import TaxbillStaticsViewPage from './pages/taxbill_statics/TaxbillStaticsViewPage';
import BondsDeptsStaticsViewPage from './pages/bonds-depts-statics/BondsDeptsStaticsViewPage';
import CollectsBuysStaticsViewPage from './pages/collects-buys-statics/CollectsBuysStaticsViewPage';
import SalesEstimateListPage from './pages/sales_estimate/SalesEstimateListPage';
import BuysEstimateListPage from './pages/buys_estimate/BuysEstimateListPage';
import BuysOrderSheetPage from './pages/buys_order_sheet/BuysOrderSheetPage';
import SalesOrderSheetPage from './pages/sales_order_sheet/SalesOrderSheetPage';
import SalesmanStaticsViewPage from './pages/salesman-statics/SalesmanStaticsViewPage';
import SalesStaticsViewPage from './pages/sales-statics/SalesStaticsViewPage';
import ApprovalMonitorListPage from './pages/approval_monitoring/ApprovalMonitorListPage';
import ApprovalMonitorViewPage from './pages/approval_monitoring/ApprovalMonitorViewPage';
import ObtainorderStaticsPage from './pages/obtainorder_statics/ObtainorderStaticsPage';
import SalesresultsStaticsPage from './pages/salesresults_statics/SalesresultsStaticsPage';
import ProfitresultsStaticsPage from './pages/profitresults_statics/ProfitresultsStaticsPage';

import ProjectOrdersListPage from './pages/project_orders/ProjectOrdersListPage';
import AccountSalesManageViewPage from './pages/account-sales-manage-statics/AccountSalesManageViewPage';
import SalesManageViewPage from './pages/sales-manage-statics/SalesManageViewPage';

import ChanceFailListPage from './pages/chance-fail/ChanceFailListPage';
import IndividualSalaryInputPage from './pages/budget-manage/IndividualSalaryInputPage';
import BudgetPage from './pages/establish/BudgetPage';
import BudgetToActualPage from './pages/budgettoactual/BudgetToActualPage';
import IndividualDirectcostbudgetPage from './pages/budget-manage/IndividualDirectcostbudgetPage';
import TotalOverheadBudgetInputPage from './pages/budget-manage/TotalOverheadBudgetInputPage';
import HeadquarterBudgetInputPage from './pages/budget-manage/HeadquarterBudgetInputPage';
import TeamBudgetInputPage from './pages/budget-manage/TeamBudgetInputPage';
import SalesMngCostStatsPage from './pages/sales_mng_cost_stats/SalesMngCostStatsPage';
import SalesMngCostStatsPageNew from './pages/sales_mng_cost_stats_new/SalesMngCostStatsPageNew';
import SalesMngCostStatsPageViewNew from './pages/sales_mng_cost_stats_view_new/SalesMngCostStatsPageViewNew';

import CommonCostStatsPage from './pages/common-cost-stats/CommonCostStatsPage';
import SalesCostManageListPage from './pages/sales-cost-manage/SalesCostManageListPage';

import BillsAccountsPage from './pages/balance-accounts/BillsAccountsPage';
import ForecastResultsPage from './pages/balance-accounts/ForecastResultsPage';
import MonthsAccountsPage from './pages/balance-accounts/MonthsAccountsPage';
import Top50CompanyAccountsPage from './pages/balance-accounts/Top50CompanyAccountsPage';
import GroupsAccountsPage from './pages/balance-accounts/GroupsAccountsPage';

import CarMngPage from './pages/carmng/CarMngPage';
import CarListPage from './pages/carmng/CarListPage';
import CarReservListPage  from './pages/carmng/CarReservListPage';
import CarRegPage  from './pages/carmng/CarRegPage';
import CarReservPage  from './pages/carmng/CarReservPage';

import CarAssetPage from './pages/carmng/CarAssetPage';
import CarAssetListPage from './pages/carmng/CarAssetListPage';

import SalesActivityPage from './pages/salesActivity/SalesActivityPage';
import SalesActionPage from './pages/salesAction/SalesActionPage';
import SalesActionStatPage from './pages/salesActionStat/SalesActionStatPage';
import HolidayMngPage from './pages/holidayMng/HolidayMngPage';
import SalesPerformancePage from './pages/salesPerformance/SalesPerformancePage';
import ClentPerformanceStatPage from './pages/clientPerformanceStat/ClientPerformanceStatPage';

import TechActivityPage from './pages/techActivity/TechActivityPage';
import TechActionPage from './pages/techAction/TechActionPage';
import TechActionStatPage from './pages/techActionStat/TechActionStatPage';
LicenseInfo.setLicenseKey(
  'ee3cbe6ccbbd798803504d814dd150efT1JERVI6MzY5MTMsRVhQSVJZPTE2NzUxNTc1MjYwMDAsS0VZVkVSU0lPTj0x',
);


function PrivateOutlet() {
  const location = useLocation();
  const auth = localStorage.getItem('access_token');
  return auth ? <MainPage /> : <Navigate to="/login" state={{ from: location.pathname }} replace />;
}

const IndexRedirect = () => {
  const loginMode = localStorage.getItem('loginMode');
  
  // 'car_service' 모드이면 차량 대시보드로, 아니면 일반 대시보드로 이동
  const targetPath = loginMode === 'car_service' ? '/carusage' : '/dashboard';
  
  return <Navigate to={targetPath} replace />;
};

const App = () => {
  
  
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<PrivateOutlet />}>
          {/*<Route index element={<Navigate to="/dashboard" />} />*/}

          <Route index element={<IndexRedirect />} />

          <Route path="dashboard" element={<DashboardPage />} />
          
          {/* 경영 정보 */}
          <Route path="goal_statics" element={<GoalStaticsMngPage />}>
            <Route index element={<GoalStaticsViewPage />} />
            <Route path="detail" element={<GoalStaticsViewDetailPage />} />
          </Route>
          <Route path="obtainorder_statics" element={<ObtainorderStaticsPage />} />
          <Route path="salesresults_statics" element={<SalesresultsStaticsPage />} />
          <Route path="profitresults_statics" element={<ProfitresultsStaticsPage />} />
          <Route path="budgettoactual" element={<BudgetToActualPage />} />
          <Route
            path="sales-mng-cost-stats-view-new"
            element={<SalesMngCostStatsPageViewNew />}
          />
          <Route
            path="clientPerformanceStat"
            element={<ClentPerformanceStatPage />}
          />
          <Route path="partnermng" element={<PartnerMngPage />}>
            <Route index element={<PartnerListPage />} />
            <Route path="add" element={<PartnerAddPage />} />
            <Route path=":id" element={<PartnerViewPage />} />
            <Route path=":id/edit" element={<PartnerEditPage />} />
          </Route>

          <Route path="employeemng" element={<EmployeeMngPage />}>
            <Route index element={<EmployeeListPage />} />
            <Route path="add" element={<EmployeeAddPage />} />
            <Route path=":id" element={<EmployeeViewPage />} />
            <Route path=":id/edit" element={<EmployeeEditPage />} />
          </Route>
          {/* 영업 활동 관리 */}
          <Route path="salesActivity">
            <Route index element={<SalesActivityPage />} />
          </Route>
          <Route path="salesAction">
            <Route index element={<SalesActionPage />} />
          </Route>
          <Route path="salesActionStat">
            <Route index element={<SalesActionStatPage />} />
          </Route>
          <Route path="holidayMng">
            <Route index element={<HolidayMngPage />} />
          </Route>
          <Route path="salesPerformance">
            <Route index element={<SalesPerformancePage />} />
          </Route>
               {/* 영업 활동 관리 */}
          <Route path="techActivity">
            <Route index element={<TechActivityPage />} />
          </Route>
          <Route path="techAction">
            <Route index element={<TechActionPage />} />
          </Route>
          <Route path="techActionStat">
            <Route index element={<TechActionStatPage />} />
          </Route>
          {/* 포캐스팅 관리 */}
          <Route
            path="forecastmonthstat"
            element={<ForecastMonthStatMngPage />}
          >
            <Route index element={<ForecastMonthStatViewPage />} />
          </Route>
          <Route path="forecaststat" element={<ForecastStatMngPage />}>
            <Route index element={<ForecastStatViewPage />} />
          </Route>
          <Route path="chancemng" element={<ChanceMngPage />}>
            <Route index element={<ChanceListPage />} />
            {/* <Route path="add" element={<ChanceAddPage />} /> */}
            <Route path="addForecast" element={<ChanceAddForecastPage />} />
            <Route path=":id/:step/:tab" element={<ChanceDetailPage />} />
              {/* <Route path=":step/:tab" element={<ChanceStepPage />} />
            </Route>*/}
          </Route>

          <Route path="chance-fail">
            <Route index element={<ChanceFailListPage />} />
          </Route>

          <Route path="sales_estimate">
            <Route index element={<SalesEstimateListPage />} />
          </Route>
          <Route path="buys_estimate">
            <Route index element={<BuysEstimateListPage />} />
          </Route>

          <Route path="sales_order_sheet">
            <Route index element={<SalesOrderSheetPage />} />
          </Route>
          <Route path="buys_order_sheet">
            <Route index element={<BuysOrderSheetPage />} />
          </Route>

          {/* 수주 관리 */}
          
          <Route path="project_orders">
            <Route index element={<ProjectOrdersListPage />} />
          </Route>
          <Route path="project_dept_stat" element={<ProjectDeptStatMngPage />}>
            <Route index element={<ProjectDeptStatViewPage />} />
          </Route>
          <Route
            path="maintance_dept_stat"
            element={<MaintanceDeptStatMngPage />}
          >
            <Route index element={<MaintanceDeptStatViewPage />} />
          </Route>

          <Route
            path="project_dept_count"
            element={<ProjectDeptCountMngPage />}
          >
            <Route index element={<ProjectDeptCountViewPage />} />
          </Route>
          <Route path="vendor_dept_stat" element={<VendorDeptStatMngPage />}>
            <Route index element={<VendorDeptStatViewPage />} />
          </Route>

          <Route path="projectmng" element={<ProjectMngPage />}>
            <Route index element={<ProjectListPage />} />
            <Route path=":id" element={<ProjectDetailPage />}>
              <Route path=":step/:tab" element={<ProjectStepPage />} />
            </Route>
          </Route>

          <Route path="maintancetmng" element={<MaintanceMngPage />}>
            <Route index element={<MaintanceListPage />} />
            <Route path=":id" element={<MaintanceDetailPage />}>
              <Route path=":step/:tab" element={<MaintanceStepPage />} />
            </Route>
          </Route>

          <Route path="etcmng" element={<EtcMngPage />}>
            <Route index element={<EtcListPage />} />
            <Route path=":id" element={<EtcDetailPage />}>
              <Route path=":step/:tab" element={<EtcStepPage />} />
            </Route>
          </Route>
          <Route path="invoice_maintenance" element={<InvoiceMaintenanceMngPage />} />
          <Route path="purchase_maintenance" element={<PurchaseMaintenanceMngPage />} />
          {/* 세금계산서 관리 */}

          <Route path="paymentmng" element={<PaymentMngPage />}>
            <Route index element={<PaymentListPage />} />
            <Route path="add" element={<PaymentAddPage />} />
            <Route path=":id" element={<PaymentViewPage />} />
            <Route path=":id/edit" element={<PaymentEditPage />} />
          </Route>

          <Route path="taxbillmng" element={<TaxbillMngPage />}>
            <Route index element={<TaxbillListPage />} />
            <Route path="add" element={<TaxbillAddPage />} />
            <Route path=":id" element={<TaxbillViewPage />} />
            <Route path=":id/edit" element={<TaxbillEditPage />} />
          </Route>

          {/** 채권/채무관리 */}
          <Route path="bonds-depts">
            <Route index element={<BondDeptListPage />} />
          </Route>
          <Route path="collects-buys">
            <Route index element={<CollectBuyListPage />} />
          </Route>

          <Route path="taxIssuedmng" element={<TaxIssuedMngPage />}>
            <Route index element={<TaxIssuedListPage />} />
            <Route path="add" element={<TaxIssuedAddPage />} />
            <Route path=":id" element={<TaxIssuedViewPage />} />
            <Route path=":id/edit" element={<TaxIssuedEditPage />} />
          </Route>

          <Route path="salesgoalmng" element={<SaleGoalMngPage />}>
            <Route index element={<SaleGoalViewPage />} />
            <Route path="edit" element={<SaleGoalEditPage />} />
          </Route>

          {/* 기술지원 */}
          <Route path="techmng" element={<TechMngPage />}>
            <Route index element={<TechProjectListPage />} />
            <Route path=":id" element={<TechProjectDetailPage />}>
              <Route path=":step/:tab" element={<TechStepPage />} />
            </Route>
          </Route>

          <Route path="reqtechmng" element={<ReqTechMngPage />}>
            <Route index element={<ReqTechListPage />} />
            <Route path=":id" element={<ReqTechViewPage />} />
          </Route>

          <Route path="plantechmng" element={<PlanTechMngPage />}>
            <Route index element={<PlanTechListPage />} />
            <Route path=":id" element={<PlanTechViewPage />} />
          </Route>

          <Route path="rslttechmng" element={<RsltTechMngPage />}>
            <Route index element={<RsltTechListPage />} />
            <Route path=":id" element={<RsltTechViewPage />} />
          </Route>

          {/* 결산관리 */}
          {/* <Route path="techstat" element={<TechStatMngPage />}>
            <Route index element={<TechStatViewPage />} />
          </Route> */}

          <Route path="groups-accounts" element={<GroupsAccountsPage />} />
          <Route path="bills-accounts" element={<BillsAccountsPage />} />
          <Route
            path="top50-company-accounts"
            element={<Top50CompanyAccountsPage />}
          />
          <Route path="months-accounts" element={<MonthsAccountsPage />} />
          <Route path="forecast-results" element={<ForecastResultsPage />} />

          <Route path="sales-statics" element={<SalesStaticsViewPage />} />

          <Route
            path="account-sales-manage-statics"
            element={<AccountSalesManageViewPage />}
          />
          <Route
            path="sales-manage-statics"
            element={<SalesManageViewPage />}
          />
          <Route path="common-cost-stats" element={<CommonCostStatsPage />} />

          {/* <Route
            path="total-common-cost-statics"
            element={<TotalCommonCostManageViewPage />}
          /> */}

          {/* 판매관리비 관리 
          <Route
            path="sales-cost-manage"
            element={<SalesCostManageListPage />}
          />*/}
          {/* 판매관리비 등록 */}
          <Route
            path="sales-mng-cost-stats"
            element={<SalesMngCostStatsPage />}
          />
          <Route
            path="sales-mng-cost-stats-new"
            element={<SalesMngCostStatsPageNew />}
          />
         
          
          <Route path="taxbill_statics" element={<TaxbillStaticsMngPage />}>
            <Route index element={<TaxbillStaticsViewPage />} />
          </Route>

          <Route path="bonds-depts-statics">
            <Route index element={<BondsDeptsStaticsViewPage />} />
          </Route>

          <Route path="collects-buys-statics">
            <Route index element={<CollectsBuysStaticsViewPage />} />
          </Route>

          {/* 결산 관리 */}
          <Route
            path="salesman-statics"
            element={<SalesmanStaticsViewPage />}
          />

          <Route
            path="individual-salary-input"
            element={<IndividualSalaryInputPage />}
          />
          <Route
            path="individual-directcost-budget"
            element={<IndividualDirectcostbudgetPage />}
          />
          <Route
            path="total-overhead-budget-input"
            element={<TotalOverheadBudgetInputPage />}
          />
          <Route
            path="headquarter-budget-input"
            element={<HeadquarterBudgetInputPage />}
          />
          <Route path="team-budget-input" element={<TeamBudgetInputPage />} />

          {/* 예산 관리 */}
           <Route path="establish/budget" element={<BudgetPage />} />

          {/* 목표 설정 */}
          <Route path="goalsetting" element={<GoalSettingMngPage />}>
            <Route path=":deptId" element={<GoalDeptUserPage />}>
              <Route path=":id" element={<GoalSettingPage />} />
            </Route>
          </Route>

          {/* 제품관리 */}
          <Route path="productmng" element={<ProductMngPage />}>
            <Route index element={<ProductListPage />} />
            <Route path="add" element={<ProductAddPage />} />
            <Route path=":id" element={<ProductViewPage />} />
            <Route path=":id/edit" element={<ProductEditPage />} />
          </Route>

          <Route path="inventorymng" element={<InventoryMngPage />}>
            <Route index element={<InventoryProductsPage />} />
            <Route path="history" element={<InventoryHistoryPage />} />
          </Route>

          <Route path="profile" element={<ProfileMngPage />}>
            <Route index element={<ProfileViewPage />} />
            <Route path="edit" element={<ProfileEditPage />} />
          </Route>

          {/* 공통관리 */}
          <Route path="codemng" element={<CodeMngPage />} />

          <Route path="deptmng" element={<DeptMngPage />}>
            <Route path=":id" element={<DeptViewPage />} />
            <Route path=":id/edit" element={<DeptEditPage />} />
          </Route>

          <Route path="authmenumng" element={<AuthMenuMngPage />}>
            <Route path=":id" element={<AuthMenuViewPage />} />
          </Route>

          <Route path="usermenumng" element={<UserMenuMngPage />}>
            <Route path=":id" element={<UserMenuViewPage />} />
          </Route>

          <Route path="approvalmng" element={<ApprovalMngPage />}>
            <Route index element={<ApprovalListPage />} />
            <Route path=":id" element={<ApprovalViewPage />} />
          </Route>

          <Route path="approval_monitoring">
            <Route index element={<ApprovalMonitorListPage />} />
            <Route path=":id" element={<ApprovalMonitorViewPage />} />
          </Route>

          <Route path="schedulemng" element={<ScheduleMngPage />}>
            <Route index element={<ScheduleViewPage />} />
          </Route>

          <Route path="noticemng" element={<NoticeMngPage />}></Route>

          {/* 자동차 이용 관리 */}
          <Route path="carasset" element={<CarAssetPage />}>
            <Route index element={<CarAssetListPage />} />
          </Route>
          <Route path="carusage" element={<CarMngPage />}>
            <Route index element={<CarListPage />} />
            <Route path="reservUsage" element={<CarReservListPage />} />
            <Route path="registration" element={<CarRegPage />} />
            <Route path="reservation" element={<CarReservPage />} />
          </Route>
        </Route>

        <Route path="login" element={<LoginPage />} />
        <Route
          path="*"
          element={
            <main style={{ padding: '1rem' }}>
              <p>There's nothing here!</p>
            </main>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default App;
